// extracted by mini-css-extract-plugin
export default {"updateConfig":"DShkwyOfkdryOI6t_2aP","message":"wMke_fXOSqEqrpVIMszK","messageHeading":"cPeWNVFKP8SfuuT4sTag","messageParagraph":"MtwpqB6zXMq3tWxFBzhg"};